import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, AuthField, SubmitButton } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(errorMessage(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Forgot password?" sub="Enter your account email and we'll send you a reset link."
      footer={<Link to="/login" className="font-semibold text-slate-900 underline" data-testid="forgot-back-to-login-link">Back to log in</Link>}>
      {sent ? (
        <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="forgot-password-sent">
          <MailCheck className="h-8 w-8 text-emerald-600" />
          <p className="mt-3 font-semibold text-slate-900">Check your inbox</p>
          <p className="mt-1 text-sm text-slate-600">If an account exists for {email}, a reset link is on its way. It expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <AuthField label="Email" type="email" autoComplete="email" required value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <SubmitButton loading={loading} testId="forgot-submit-button">Send reset link</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
